import { useSelectedPositionSignal } from '../../../rx/signal/useSelectedPositionSignal'
import { useSelectedPositionEntsSignal } from '../../../rx/signal/useSelectedPositionEntsSignal'
import type { Engine } from '../engine/Engine.type'
import { samePosition } from '../tile_position_xy/samePosition'
import { byEntityTypeIdAsc, byLayerIdDesc } from '../util/id'
import type { Entity } from './index'

/**
 * it would make sense for this to be a createComputed or createEffect,
 * but for now manually triggering it might be better for some subsystems
 *
 * @param engine
 */
export default function calculateSelectedPositionEnts(engine: Engine): void {
  const [getSelectedPosition] = useSelectedPositionSignal(engine)
  const [, setSelectedPositionEnts] = useSelectedPositionEntsSignal(engine)
  const selectedPosition = getSelectedPosition()
  if (selectedPosition) {
    setSelectedPositionEnts(
      engine.state.ents
        .filter((ent: Entity) => samePosition(ent, selectedPosition))
        .sort(byEntityTypeIdAsc)
        .sort(byLayerIdDesc)
    )
  } else {
    setSelectedPositionEnts([])
  }
}
